/* Guide article template enhancements. Loaded deferred, only by
   sections/main-article-guide.liquid. Every transform is a pure
   progressive enhancement over the converter's fixed HTML
   (h2/h3, p, ul/ol, table, strong-prefixed FAQ) and is guarded so
   a pattern mismatch silently no-ops — the page must always read
   perfectly without any of this running. */
(function () {
  'use strict';

  /* Bootstrap: run as soon as this section's markup is parsed, without
     depending on DOMContentLoaded — a hanging third-party script must not
     block these enhancements. Polls briefly for the section's last element. */
  function whenReady(fn) {
    var tries = 0;
    (function check() {
      if (document.querySelector('.guide-article .ga-latest')) return fn();
      if (document.readyState === 'complete' || tries > 75) {
        if (document.querySelector('.guide-article')) fn();
        return;
      }
      tries += 1;
      setTimeout(check, 200);
    })();
  }

  whenReady(init);

  function init() {

  var root = document.querySelector('.guide-article');
  if (!root) return;
  var body = root.querySelector('#ga-body');
  if (!body) return;

  function slugify(text) {
    return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
  }

  function guard(fn) {
    try { fn(); } catch (e) { /* enhancement only — never break reading */ }
  }

  function makeChevron() {
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'ga-faq__chev');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS(NS, 'path');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    path.setAttribute('d', 'M3 6l5 5 5-5');
    svg.appendChild(path);
    return svg;
  }

  /* 1. Heading ids (shared by TOC + inline embeds) */
  var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
  guard(function () {
    var used = {};
    headings.forEach(function (h) {
      if (!h.id) {
        var slug = slugify(h.textContent);
        while (used[slug]) slug += '-x';
        used[slug] = true;
        h.id = slug;
      }
    });
  });

  /* 2. FAQ accordion from the strong-Q pattern (before band wrapping) */
  guard(function () {
    var faqHeading = headings.filter(function (h) {
      return /faq|frequently asked/i.test(h.textContent);
    })[0];
    if (!faqHeading) return;
    var node = faqHeading.nextElementSibling;
    var items = [];
    while (node && !/^H2$/i.test(node.tagName)) {
      var next = node.nextElementSibling;
      if (/^P$/i.test(node.tagName) && node.firstElementChild && /^STRONG$/i.test(node.firstElementChild.tagName)) {
        items.push(node);
      }
      node = next;
    }
    if (!items.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'ga-faq ga-wide';
    items[0].parentNode.insertBefore(wrap, items[0]);
    items.forEach(function (p) {
      var strong = p.firstElementChild;
      var question = strong.textContent.trim();
      strong.remove();
      /* drop leading whitespace/<br> left behind by the question */
      while (p.firstChild && (
        (p.firstChild.nodeType === 3 && !p.firstChild.textContent.trim()) ||
        (p.firstChild.nodeType === 1 && /^BR$/i.test(p.firstChild.tagName))
      )) { p.removeChild(p.firstChild); }
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      var q = document.createElement('span');
      q.textContent = question;
      summary.appendChild(q);
      summary.appendChild(makeChevron());
      var answer = document.createElement('div');
      answer.className = 'ga-faq__a';
      var answerP = document.createElement('p');
      while (p.firstChild) answerP.appendChild(p.firstChild); /* move existing DOM nodes */
      answer.appendChild(answerP);
      details.appendChild(summary);
      details.appendChild(answer);
      wrap.appendChild(details);
      p.remove();
    });
  });

  /* 3. Callout promotion: <p><strong>Tip:/Note:/Key fact:/Warning:/Pro tip:</strong> …</p> */
  guard(function () {
    var ICONS = {
      tip: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2a5.5 5.5 0 0 0-3 10.1V14a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.9A5.5 5.5 0 0 0 10 2z"/><path d="M8.5 17.5h3"/></svg>',
      warn: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10 3 2.5 16.5h15L10 3z"/><path d="M10 8.5v3.5"/><circle cx="10" cy="14.5" r=".5" fill="currentColor"/></svg>'
    };
    /* parse the two static icon constants once via DOMParser (no live-DOM HTML sink) */
    var parser = new DOMParser();
    var iconNodes = {};
    Object.keys(ICONS).forEach(function (k) {
      iconNodes[k] = parser.parseFromString(ICONS[k], 'image/svg+xml').documentElement;
    });
    Array.prototype.slice.call(body.querySelectorAll('p')).forEach(function (p) {
      var strong = p.firstElementChild;
      if (!strong || !/^STRONG$/i.test(strong.tagName) || p.firstChild !== strong) return;
      var m = strong.textContent.match(/^(Tip|Pro tip|Note|Key fact|Warning)\s*:/i);
      if (!m) return;
      var kind = /warning/i.test(m[1]) ? 'warn' : 'tip';
      var callout = document.createElement('aside');
      callout.className = 'ga-callout ga-callout--' + kind;
      var icon = document.createElement('span');
      icon.className = 'ga-callout__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.appendChild(iconNodes[kind].cloneNode(true));
      callout.appendChild(icon);
      var content = document.createElement('p');
      while (p.firstChild) content.appendChild(p.firstChild);
      callout.appendChild(content);
      p.parentNode.replaceChild(callout, p);
    });
  });

  /* 4. Table upgrades: wrapper, numeric alignment, yes/no pills, card-stack labels */
  guard(function () {
    Array.prototype.slice.call(body.querySelectorAll('table')).forEach(function (table) {
      if (table.closest('.ga-table')) return;
      var wrap = document.createElement('div');
      wrap.className = 'ga-table ga-wide';
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('tabindex', '0');
      var caption = table.querySelector('caption');
      var prevH = table.previousElementSibling;
      wrap.setAttribute('aria-label', caption ? caption.textContent.trim() : (prevH && /^H[23]$/i.test(prevH.tagName) ? prevH.textContent.trim() + ' — table' : 'Data table'));
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);

      var headers = Array.prototype.slice.call(table.querySelectorAll('thead th')).map(function (th) {
        return th.textContent.trim();
      });
      var rows = Array.prototype.slice.call(table.querySelectorAll('tbody tr'));

      /* numeric column detection */
      headers.forEach(function (_, col) {
        if (col === 0) return;
        var numeric = rows.length > 0 && rows.every(function (tr) {
          var td = tr.children[col];
          if (!td) return false;
          var t = td.textContent.trim();
          return t === '' || /^[~<>≈]?\s*[£$€]?[\d.,]+\s*(%|kg|g|l|ml|m|cm|mm|w|min|hrs?|m³\/h|cfm)?$/i.test(t);
        });
        if (numeric) {
          rows.forEach(function (tr) { if (tr.children[col]) tr.children[col].setAttribute('data-numeric', ''); });
          var th = table.querySelectorAll('thead th')[col];
          if (th) th.setAttribute('data-numeric', '');
        }
      });

      /* yes/no pills */
      rows.forEach(function (tr) {
        Array.prototype.slice.call(tr.children).forEach(function (td, i) {
          if (i === 0) return;
          var t = td.textContent.trim();
          var pillKind = /^(yes|✓|✔)$/i.test(t) ? 'yes' : (/^(no|✗|✕|—|–)$/i.test(t) ? 'no' : null);
          if (pillKind) {
            var pill = document.createElement('span');
            pill.className = 'ga-pill ga-pill--' + pillKind;
            pill.textContent = t;
            td.textContent = '';
            td.appendChild(pill);
          }
        });
      });

      /* card-stack labels (only stack simple tables: ≤4 columns) */
      if (headers.length > 0 && headers.length <= 4) {
        wrap.classList.add('ga-table--stack');
        rows.forEach(function (tr) {
          Array.prototype.slice.call(tr.children).forEach(function (td, i) {
            if (headers[i]) td.setAttribute('data-label', headers[i]);
          });
        });
      }
    });
  });

  /* 5. Inline product embeds: cards render in a visible fallback list
        (correct with JS off); move each to its anchor heading here. */
  guard(function () {
    var fallback = document.getElementById('ga-embed-fallback');
    if (!fallback) return;
    Array.prototype.slice.call(fallback.querySelectorAll('.ga-embed[data-ga-anchor]')).forEach(function (card) {
      var anchor = document.getElementById(card.getAttribute('data-ga-anchor'));
      if (!anchor) return; /* stays in the fallback list */
      var target = anchor.nextElementSibling;
      if (target && /^P$/i.test(target.tagName)) {
        target.parentNode.insertBefore(card, target.nextSibling);
      } else {
        anchor.parentNode.insertBefore(card, anchor.nextSibling);
      }
    });
    if (!fallback.querySelector('.ga-embed')) fallback.hidden = true;
  });

  /* 6. Section bands: wrap each h2 run, tint alternates */
  guard(function () {
    var kids = Array.prototype.slice.call(body.children);
    var firstH2 = body.querySelector('h2');
    if (!firstH2) return;
    var bands = [];
    var current = null;
    kids.forEach(function (el) {
      if (/^H2$/i.test(el.tagName)) {
        current = document.createElement('section');
        current.className = 'ga-band';
        body.insertBefore(current, el);
        bands.push(current);
      }
      if (current) current.appendChild(el);
    });
    bands.forEach(function (band, i) {
      if (i % 2 === 1) band.classList.add('ga-band--tint');
    });
  });

  /* 7. TOC (desktop sidebar + mobile details) + scroll-spy */
  guard(function () {
    if (headings.length < 3) return;
    ['ga-toc-desktop', 'ga-toc-mobile'].forEach(function (id) {
      var toc = document.getElementById(id);
      if (!toc) return;
      var list = toc.querySelector('.ga-toc__list');
      if (!list) return;
      headings.forEach(function (h) {
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        list.appendChild(a);
      });
      toc.hidden = false;
    });

    if ('IntersectionObserver' in window) {
      var links = root.querySelectorAll('.ga-toc__list a');
      var visible = {};
      var setActive = function (id) {
        links.forEach ? null : 0;
        Array.prototype.forEach.call(links, function (l) {
          l.classList.toggle('is-active', l.getAttribute('href') === '#' + id);
        });
      };
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { visible[e.target.id] = e.isIntersecting; });
        for (var i = 0; i < headings.length; i++) {
          if (visible[headings[i].id]) { setActive(headings[i].id); return; }
        }
      }, { rootMargin: '-40% 0px -55% 0px' });
      headings.forEach(function (h) { observer.observe(h); });
    }

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      Array.prototype.forEach.call(root.querySelectorAll('.ga-toc__list a'), function (a) {
        a.addEventListener('click', function (e) {
          var target = document.getElementById(a.getAttribute('href').slice(1));
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', a.getAttribute('href'));
        });
      });
    }
  });

  }
})();
